import {Component, OnInit, ViewChild} from '@angular/core';
import {StateName, StateRequestParam} from '../../app.state-names';
import {UIRouter} from '@uirouter/angular';
import {MatDialog} from '@angular/material/dialog';
import {ColonnadeOnlineOfferPasswordDialogComponent} from './colonnade-online-offer-password-dialog.component';
import {ClientDocument} from "../../lib/client-document/client-document.service";
import {Address} from "../../lib/address";
import {ConfigurationResource, ConfigurationService} from "../../lib/configuration/configuration.service";
import {List} from "immutable";
import {TranslateService} from "@ngx-translate/core";
import PhoneNumberDataType = Address.PhoneNumberDataType;
import {TranslateUtils} from "../../util/translate";
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-colonnade-online-offer',
  templateUrl: './colonnade-online-offer.component.html',
  styleUrls: ['./colonnade-online-offer.component.scss']
})
export class ColonnadeOnlineOfferComponent implements OnInit {

  offerToken: string = '';
  clientDocument?: ClientDocument.ClientDocument;
  config: ConfigurationResource.Configuration;
  approvalModel: ApprovalModel = new ApprovalModel();
  @ViewChild('f', {static: true})
  form: NgForm;

  constructor(
    private uiRouter: UIRouter,
    private dialog: MatDialog,
    private configService: ConfigurationService,
    private translateService: TranslateService
  ) {
    this.config = configService.getConfiguration();
  }

  ngOnInit(): void {
    this.offerToken = this.uiRouter.stateService.params[StateRequestParam.COLONNADE_ONLINE_OFFER_TOKEN] || '';
    if (this.offerToken.length === 0) {
      // todo error handling
      return;
    }
    ColonnadeOnlineOfferPasswordDialogComponent.openDialog(this.dialog, {
      type: 'LOGIN',
      offerToken: this.offerToken
    }, (result) => {
      if (!result) {
        // todo error handling
      } else {
        this.clientDocument = result.clientDocument;
      }
    });
  }

  acceptOffer() {
    if (!this.form.valid) {
      return;
    }
    this.translateService.get(
      ['COLONNADE_ONLINE_FORM_PERSONAL_INFORMATION_PROVIDED_TRUE_TEXT',
        'COLONNADE_ONLINE_FORM_PERSONAL_INFORMATION_PROVIDED_FALSE_TEXT',
        'COLONNADE_ONLINE_FORM_GATHERING_PERSONAL_INFORMATION_APPROVED_TRUE_TEXT',
        'COLONNADE_ONLINE_FORM_GATHERING_PERSONAL_INFORMATION_APPROVED_FALSE_TEXT',
        'COLONNADE_ONLINE_FORM_MARKETING_RESEARCH_APPROVED_TRUE_TEXT',
        'COLONNADE_ONLINE_FORM_MARKETING_RESEARCH_APPROVED_FALSE_TEXT',
        'COLONNADE_ONLINE_FORM_HOME_INSURANCE_INTERESTED_TRUE_TEXT',
        'COLONNADE_ONLINE_FORM_HOME_INSURANCE_INTERESTED_FALSE_TEXT',
        'COLONNADE_ONLINE_FORM_PERSONAL_INFORMATION_PROVIDED_TRUE_CODE',
        'COLONNADE_ONLINE_FORM_PERSONAL_INFORMATION_PROVIDED_FALSE_CODE',
        'COLONNADE_ONLINE_FORM_GATHERING_PERSONAL_INFORMATION_APPROVED_TRUE_CODE',
        'COLONNADE_ONLINE_FORM_GATHERING_PERSONAL_INFORMATION_APPROVED_FALSE_CODE',
        'COLONNADE_ONLINE_FORM_MARKETING_RESEARCH_APPROVED_TRUE_CODE',
        'COLONNADE_ONLINE_FORM_MARKETING_RESEARCH_APPROVED_FALSE_CODE',
        'COLONNADE_ONLINE_FORM_HOME_INSURANCE_INTERESTED_TRUE_CODE',
        'COLONNADE_ONLINE_FORM_HOME_INSURANCE_INTERESTED_FALSE_CODE',]
    ).subscribe(to =>
      ColonnadeOnlineOfferPasswordDialogComponent.openDialog(this.dialog, {
        type: 'ACCEPT',
        offerToken: this.offerToken,
        consentForm: {
          personalInformationProvided: this.getConsentValue(
            this.approvalModel.personalInformationProvided,
            'COLONNADE_ONLINE_FORM_PERSONAL_INFORMATION_PROVIDED',
            to
          ),
          gatheringPersonalInformationApproved: this.getConsentValue(
            this.approvalModel.gatheringPersonalInformationApproved,
            'COLONNADE_ONLINE_FORM_GATHERING_PERSONAL_INFORMATION_APPROVED',
            to
          ),
          marketingResearchApproved: this.getConsentValue(
            this.approvalModel.marketingResearchApproved,
            'COLONNADE_ONLINE_FORM_MARKETING_RESEARCH_APPROVED',
            to
          ),
          homeInsuranceInterested: this.getConsentValue(
            this.approvalModel.homeInsuranceInterested,
            'COLONNADE_ONLINE_FORM_HOME_INSURANCE_INTERESTED',
            to
          )
        }
      }, (result) => {
        if (!result) {

        } else {
          this.uiRouter.stateService.go(StateName.COLONNADE_ONLINE_SUCCESS,{}, { location: 'replace' });
        }
      }));
  }

  private getConsentValue(isApproved: boolean, prefix: string, translations: any) {
    const suffix = isApproved ? 'TRUE' : 'FALSE';
    return {
      code: TranslateUtils.extractValueFromObject(translations, `${prefix}_${suffix}_CODE`),
      text: TranslateUtils.extractValueFromObject(translations, `${prefix}_${suffix}_TEXT`)
    };
  }

  getTitle(): string | undefined {
    return this.clientDocument?.offerId;
  }

  formatAddress(address: Address.PostalAddressData): string {
    if (!address) {
      return '';
    }
    return Address.PostalAddressMapper.toString(address, this.config.postal_address_format);
  }

  getPrivatePhoneNumber(phoneNumbers: List<Address.PhoneNumberData>): string {
    const pn = phoneNumbers.find(value => value?.type === PhoneNumberDataType.PRIVATE_MOBILE);
    if (pn && pn.value) {
      return pn.value.format();
    }
    return '';
  }

  getEmailAddress(emailAddresses: List<Address.EmailAddressData>): string {
    if (emailAddresses.isEmpty()) {
      return '';
    }
    const ea = emailAddresses.first();
    if (ea) {
      return ea.value.format();
    }
    return '';
  }

}

class ApprovalModel {
  personalInformationProvided: boolean = false;
  gatheringPersonalInformationApproved: boolean = false;
  marketingResearchApproved: boolean = false;
  homeInsuranceInterested: boolean = false;
}
